<script setup lang="ts">
import DailyReportCard from '@/components/cards/DailyReportCard.vue';
import DailyReportSearchForm from '@/components/searchForms/DailyReportSearchForm.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import useCurrentDateString from '@/composables/useCurrentDateString';
import useDailyReportView from '@/composables/views/useDailyReportView';

const { getCurrentQueryDate } = useCurrentDateString();
const { queryDate } = useCommonRouteQuery({ queryDate: getCurrentQueryDate() });
const { search, initialData, isFetchingData, dailyReportData } =
  useDailyReportView(queryDate);
</script>

<template>
  <div :class="$style.dailyReportView" data-testid="dailyReportView">
    <PageContentWrapper>
      <FormWrapper :class="$style.formWrapper">
        <DailyReportSearchForm
          :initial-data="initialData"
          :loading="isFetchingData"
          :class="$style.form"
          @submit="search"
        />
      </FormWrapper>
      <DailyReportCard
        :class="$style.dailyReportCard"
        :loading="isFetchingData"
        :data="dailyReportData"
      />
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dailyReportView {
}
  .formWrapper {
    padding: 2.4rem 1.5rem 0.5rem 1.5rem;
    max-width: 930px;
    margin: 2rem 0;
  }
  .dailyReportCard {
  }
</style>
